"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolanaMobileWalletAdapterWalletName = exports.Environment = void 0;
exports.getUserAgent = getUserAgent;
exports.getUriForAppIdentity = getUriForAppIdentity;
exports.isIOS = isIOS;
exports.isAndroid = isAndroid;
exports.isMobileDevice = isMobileDevice;
exports.getEnvironment = getEnvironment;
exports.getIsMobile = getIsMobile;
exports.isIosAndRedirectable = isIosAndRedirectable;
var wallet_adapter_base_1 = require("@solana/wallet-adapter-base");
/**
 * Environment detection enum
 */
var Environment;
(function (Environment) {
    Environment[Environment["DESKTOP_WEB"] = 0] = "DESKTOP_WEB";
    Environment[Environment["MOBILE_WEB"] = 1] = "MOBILE_WEB";
})(Environment || (exports.Environment = Environment = {}));
exports.SolanaMobileWalletAdapterWalletName = 'Mobile Wallet Adapter';
/**
 * Get the current user agent
 * @returns User agent string or null
 */
var _userAgent;
function getUserAgent() {
    var _a, _b;
    if (_userAgent === undefined) {
        _userAgent = typeof window !== 'undefined' ? (_b = (_a = window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) !== null && _b !== void 0 ? _b : null : null;
    }
    return _userAgent;
}
/**
 * Get the URI for app identity
 * @returns The protocol + host URI or undefined
 */
function getUriForAppIdentity() {
    if (typeof window === 'undefined')
        return undefined;
    var location = window.location;
    if (!location)
        return undefined;
    return "".concat(location.protocol, "//").concat(location.host);
}
/**
 * Check if the user agent string belongs to a WebView
 * @param userAgentString The user agent string to check
 * @returns true if it's a WebView
 */
function isWebView(userAgentString) {
    return /(WebView|Version\/.+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+)|; wv\).+(Chrome)\/(\d+)\.(\d+)\.(\d+)\.(\d+))/i.test(userAgentString);
}
/**
 * Check if the device is iOS
 * @param userAgentString The user agent string
 * @returns true if running on iOS device
 */
function isIOS(userAgentString) {
    return /iphone|ipad|ipod/i.test(userAgentString);
}
/**
 * Check if the device is Android
 * @param userAgentString The user agent string
 * @returns true if running on Android device
 */
function isAndroid(userAgentString) {
    return /android/i.test(userAgentString);
}
/**
 * Check if the current device is mobile
 * @param userAgentString User agent string
 * @returns true if it's a mobile device
 */
function isMobileDevice(userAgentString) {
    return (isAndroid(userAgentString) || isIOS(userAgentString)) && !isWebView(userAgentString);
}
/**
 * Determine the current environment (desktop or mobile web)
 * @param config Configuration with adapters and userAgentString
 * @returns The detected environment
 */
function getEnvironment(_a) {
    var adapters = _a.adapters, userAgentString = _a.userAgentString;
    // Early check for no user agent (e.g., server-side rendering)
    if (!userAgentString) {
        return Environment.DESKTOP_WEB;
    }
    // First check if we're on a mobile device
    if (isMobileDevice(userAgentString)) {
        return Environment.MOBILE_WEB;
    }
    // Check if any non-mobile adapters are installed
    if (adapters.some(function (adapter) {
        return adapter.name !== exports.SolanaMobileWalletAdapterWalletName &&
            adapter.readyState === wallet_adapter_base_1.WalletReadyState.Installed;
    })) {
        return Environment.DESKTOP_WEB;
    }
    // Default based on user agent again if we couldn't determine from adapters
    if (isAndroid(userAgentString) || isIOS(userAgentString)) {
        return Environment.MOBILE_WEB;
    }
    // Default to desktop
    return Environment.DESKTOP_WEB;
}
/**
 * Determine if the current environment is mobile
 * @param adapters Array of wallet adapters
 * @param userAgentString Optional user agent string (for testing)
 * @returns true if the environment is mobile
 */
function getIsMobile(adapters, userAgentString) {
    return getEnvironment({ adapters: adapters, userAgentString: userAgentString || getUserAgent() }) === Environment.MOBILE_WEB;
}
/**
 * Check if the user is on iOS and can be redirected
 * @returns true if the user can be redirected
 */
function isIosAndRedirectable() {
    // SSR: return false
    if (typeof navigator === 'undefined')
        return false;
    var userAgent = navigator.userAgent.toLowerCase();
    // if on iOS and not in a webview
    var isIos = userAgent.includes('iphone') || userAgent.includes('ipad');
    // if in a webview then it will not include Safari
    // note that other iOS browsers also include Safari
    var isSafari = userAgent.includes('safari');
    return isIos && isSafari;
}
